import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import QRCode from "qrcode.react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PublicQRPage = () => {
  const { slug } = useParams();
  const qrRef = useRef(null);

  const publicUrl = `${window.location.origin}/#/r/${slug}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(publicUrl);
      toast.success("Link copied successfully!");
    } catch (error) {
      toast.error("Failed to copy link");
    }
  };

  const handleDownload = () => {
    const svg = qrRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");

      const downloadLink = document.createElement("a");
      downloadLink.download = `${slug}-qr.png`;
      downloadLink.href = pngFile;
      downloadLink.click();

      toast.success("QR downloaded!");
    };

    img.src =
      "data:image/svg+xml;base64," +
      btoa(unescape(encodeURIComponent(svgData)));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 print:bg-white">
        <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md text-center print:shadow-none">
          
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            {slug?.toUpperCase()}
          </h2>

          <p className="text-gray-500 mb-6">
            Scan to View Menu & Order
          </p>

          <div ref={qrRef} className="flex justify-center mb-6">
            <QRCode value={publicUrl} size={220} />
          </div>

          <p className="text-sm text-gray-600 break-words mb-6">
            {publicUrl}
          </p>

          <div className="grid grid-cols-2 gap-3 print:hidden">
            <button
              onClick={handleCopy}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Copy Link
            </button>

            <button
              onClick={handleDownload}
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
            >
              Download QR
            </button>

            <button
              onClick={handlePrint}
              className="col-span-2 bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-black transition"
            >
              Print QR
            </button>
          </div>

          <p className="text-xs text-gray-400 mt-6">
            Powered by CloudRasoi
          </p>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
};

export default PublicQRPage;
